const CONSENT_KEY = 'sistinf-cookie-consent';

export function hasAnalyticsConsent() {
  const raw = localStorage.getItem(CONSENT_KEY);
  if (!raw) return false;
  try {
    return JSON.parse(raw) === 'true';
  } catch {
    return raw === 'true';
  }
}

let scriptInjected = false;

/**
 * Injects the Matomo tag once and configures the tracker (SPA-friendly).
 */
export function initMatomo({ url, siteId }) {
  if (typeof window === 'undefined' || !url || !siteId || scriptInjected) return;
  scriptInjected = true;
  const base = String(url).replace(/\/$/, '');
  window._paq = window._paq || [];
  window._paq.push(['setTrackerUrl', `${base}/matomo.php`]);
  window._paq.push(['setSiteId', siteId]);
  const s = document.createElement('script');
  s.async = true;
  s.src = `${base}/matomo.js`;
  document.head.appendChild(s);
}

export function trackMatomoPageView() {
  if (!hasAnalyticsConsent() || !window._paq) return;
  window._paq.push(['trackPageView']);
}
